import React, { useState } from 'react'

import CancelIcon from '@mui/icons-material/Cancel'
import { IconButton } from '@mui/material'
import { UrlProvider } from 'urls'

import CampaignCountries from 'components/campaigns/CampaignCountries'
import { type ColumnConfig, Table } from 'components/table'
import { useCampaignsReview, useCancelCampaign } from 'hooks/useCampaignsReview'
import { usePaginatedTableMeta } from 'hooks/usePaginatedTableMeta'
import type { CampaignListRow } from 'models/campaigns-model'

import CampaignDialog from '../../components/campaign-review/CampaignDialog'

const CampaignsReview = () => {
  const { meta, setPage, setRowsPerPage } = usePaginatedTableMeta({ sortBy: 'start_date' }, 'campaignsReview')
  const { data, isLoading, error } = useCampaignsReview(meta)
  const cancelCampaign = useCancelCampaign()
  const [dialog, setDialog] = useState<{ open: boolean; campaignId?: any }>({ open: false })

  const config: ColumnConfig<CampaignListRow>[] = [
    { title: 'Title', field: 'title' },
    { title: 'Customer', field: 'customer_name' },
    {
      title: 'Countries',
      render: ({ countries }) => <CampaignCountries countries={(countries || []).slice(0, 3)} />,
    },
    { title: 'Start date', field: 'start_date' },
    { title: 'End date', field: 'end_date' },
    {
      title: 'Cancel',
      field: 'cancel',
      noRowClick: true,
      render: campaignData => (
        <IconButton
          aria-label="Cancel"
          onClick={() => setDialog({ open: true, campaignId: campaignData.id })}
          size="large">
          <CancelIcon />
        </IconButton>
      ),
    },
  ]

  const getRowLink = (campaign: CampaignListRow) => UrlProvider.getUrl('campaign.review', { id: campaign.id })

  const handleCancelCampaign = () => {
    cancelCampaign.mutate(dialog.campaignId)
    setDialog({ open: false })
  }

  return (
    <div>
      <Table
        className="campaigns-monitoring__table"
        config={config}
        count={data?.count}
        data={data?.items}
        error={error ? 'Error occurred when loading campaigns data' : undefined}
        getRowLink={getRowLink}
        hover
        loading={isLoading}
        onChangePage={setPage}
        onChangeRowsPerPage={setRowsPerPage}
        page={meta.page}
        rowsPerPage={meta.rowsPerPage}
        title="Campaigns Review"
      />
      <CampaignDialog
        isDialogOpen={dialog.open}
        onCancel={() => setDialog({ open: false })}
        onConfirm={handleCancelCampaign}
      />
    </div>
  )
}

export default CampaignsReview
